import { MAX_RANGE_DATA_BUFFER_SIZE, RangeDataBuffer, RowWriteOptions } from './range-data-buffer';
import { findLastSequentialIndex } from './range-utils';

export class RangesValuesWriter {
  private buffer = new RangeDataBuffer();

  constructor(
    private context: Excel.RequestContext,
    private options: {
      insertColumnsCount?: number;
    } = {},
  ) {}

  private async writeBufferToWorksheet(buffer: RangeDataBuffer) {
    const rangeNumberFormats: [Excel.Range, any[][]][] = [];
    const { insertColumnsCount } = this.options;

    for (const range of buffer.ranges) {
      range.load({ columnIndex: true, rowIndex: true, columnCount: true, rowCount: true });
      await this.context.sync();

      const rowBlocks = buffer.getRangeData(range);

      for (const rowBlock of rowBlocks) {
        let startIndex = 0;

        const { options, rows } = rowBlock;
        const { insert, rowNumberFormats } = options;

        do {
          const endIndex = findLastSequentialIndex(rows, startIndex, (item) => +item[0]);
          const rowsToInsert = rows.slice(startIndex, endIndex + 1);

          const firstRowAbsolutIndex = rowsToInsert[0][0];
          const subRangeFirstRowIndex = firstRowAbsolutIndex - range.rowIndex;
          const rangeLastRowIndex = range.rowCount - 1;
          const rowsToAdd = subRangeFirstRowIndex > rangeLastRowIndex ? subRangeFirstRowIndex - rangeLastRowIndex : 0;

          let subRange = range
            .getResizedRange(rowsToAdd, 0)
            .getRow(subRangeFirstRowIndex)
            .getAbsoluteResizedRange(rowsToInsert.length, range.columnCount);

          if (insertColumnsCount) {
            const columnsToInsert = subRange.getColumnsAfter(insertColumnsCount);
            columnsToInsert.insert('Right');
            subRange = subRange.getResizedRange(0, insertColumnsCount);
          }
          if (insert) {
            subRange = subRange.insert('Down');
          }
          subRange.values = rowsToInsert.map((row: any) => row.slice(1));

          if (rowNumberFormats) {
            rangeNumberFormats.push([subRange, rowsToInsert.map(() => rowNumberFormats)]);
          }

          startIndex = endIndex + 1;
        } while (startIndex < rows.length);
      }
    }
    await this.context.sync();

    if (rangeNumberFormats.length > 0) {
      for (const item of rangeNumberFormats) {
        const [range, numberFormats] = item;
        range.numberFormat = numberFormats;
      }
      await this.context.sync();
    }
  }

  async writeValues(range: Excel.Range, row: any[], options?: RowWriteOptions) {
    const rowSize = RangeDataBuffer.calcRowSize(row);

    if (this.buffer.size + rowSize > MAX_RANGE_DATA_BUFFER_SIZE) {
      await this.writeBufferToWorksheet(this.buffer);
      this.buffer = new RangeDataBuffer();
    }

    this.buffer.addRowForRange(range, row, rowSize, options);
  }

  async flushBuffer() {
    if (this.buffer.size > 0) {
      await this.writeBufferToWorksheet(this.buffer);
      this.buffer = new RangeDataBuffer();
    }
  }
}
